import { computed, ref } from 'vue'

const sidebarVisible = ref(false)

export function useMapSidebar() {

  const toggle = () => {
    sidebarVisible.value = !sidebarVisible.value
  }

  const show = () => {
    sidebarVisible.value = true
  }

  const hide = () => {
    sidebarVisible.value = false
  }

  const isVisible = computed(() => sidebarVisible.value)

  return {
    show,
    hide,
    toggle,
    isVisible,
  }
}